import { useEffect, useState } from 'react'
import api from '../../utils/api'

const BUYAPOWA_KEY = 'bp_e'

const getUrlBuyapowaCode = (searchParams) => {
  const urlParams = new URLSearchParams(searchParams)
  const code = urlParams.get(BUYAPOWA_KEY)
  // Param values can resolve to empty strings, so lets be consistent and return null
  if (code === null || code === '') {
    return null
  }

  return code
}

export default (doFindFriend, contentKey) => {
  const [requestingBannerContent, setRequestingBannerContent] = useState(false)
  const [bannerContent, setBannerContent] = useState(null)

  useEffect(() => {
    const getFriend = async () => {
      const buyapowaCode = getUrlBuyapowaCode(window.location.search)
      if (buyapowaCode) {
        // Compatible with Sundae i.e. does exact same thing
        try {
          const response = await api.get(
            `/findFriend?friendToken=${buyapowaCode}`
          )
          const { data } = response.data
          const { customer_id, voucher_code, email } = data.attributes
          window.localStorage.setItem('referrer_voucher_code', voucher_code)
          window.localStorage.setItem('referrer_customer_id', customer_id)
          window.localStorage.setItem('referrer_customer_email', email)
          if (!bannerContent) {
            getContent()
          }
        } catch (e) {
          // Do nothing.
        }
      }
    }

    const getContent = async () => {
      if (!requestingBannerContent) {
        try {
          setRequestingBannerContent(true)
          const referrerId = window.localStorage.getItem('referrer_customer_id')
          const referrerEmail = window.localStorage.getItem(
            'referrer_customer_email'
          )
          // Fails silently e.g. users that never use a RAF link
          if (referrerId) {
            const response = await api.get('/referrer', {
              params: {
                referrer_id: referrerId,
                referrer_email: referrerEmail,
              },
            })
            const { data } = response.data
            const { attributes } = data
            // When it's a campaign (non-RAF), this item must be removed
            const content = attributes[contentKey]
            setBannerContent(content)
            setRequestingBannerContent(false)
          }
        } catch (e) {
          // Do nothing
        }
      }
    }

    // If coming to the `/friend` route, use the findFriend endpoint
    // (This will in turn get banner content)
    // Otherwise, look in local storage and try get banner content
    if (doFindFriend) {
      getFriend()
    } else {
      getContent()
    }
  }, [])

  return bannerContent
}
